async function getSteps(prompt, choice) {

    const parameters = {
        method: "POST",
        body: JSON.stringify({message: "Provide detailed step-by-step instructions on how to develop the skills required for " + choice + " in the context of " + prompt + ". Integrate any relevant resources/references with URLs. Respond in JSON format: [{step number: '', overview: '', details: '', resources: [{resource: '', url: ''},...]},...]"}),
        headers: {"Content-Type": "application/json"}
    }

    try {
        const response = await fetch(`/api/completions`, parameters)
        if (!response.ok) return null
        const data = await response.json()
        const steps = JSON.parse(data.candidates[0].content.parts[0].text)
        if (!Array.isArray(steps)) return null
        return steps
    } catch (error) {
        console.error(error)
        return null
    }
}

export default getSteps
